const PLATFORM_TO_AWS_BASE = {
    us: 'en',
    mx: 'es',
    ho: 'nl',
    cz: 'cs',
    si: 'sl',
    se: 'sv',
    rs: 'sr',
    si_lk: 'si',
    zh_tw: 'zh',
    fr_ca: 'fr',
    pt_pt: 'pt',
    es_mx: 'es',
    fa_af: 'fa',
};

const UI_I18N_DISPLAY_NAMES = {
    af: 'Afrikaans',
    sq: 'Albanian',
    am: 'Amharic',
    ar: 'Arabic',
    hy: 'Armenian',
    az: 'Azerbaijani',
    eu: 'Basque',
    be: 'Belarusian',
    bn: 'Bengali',
    bs: 'Bosnian',
    bg: 'Bulgarian',
    my: 'Burmese',
    ca: 'Catalan',
    zh: 'Chinese (Simplified)',
    zh_tw: 'Chinese (Traditional)',
    hr: 'Croatian',
    cz: 'Czech',
    da: 'Danish',
    fa_af: 'Dari',
    ho: 'Dutch',
    et: 'Estonian',
    fo: 'Faroese',
    tl: 'Filipino (Tagalog)',
    fi: 'Finnish',
    fr: 'French',
    fr_ca: 'French (Canada)',
    fy: 'Frisian',
    gl: 'Galician',
    ka: 'Georgian',
    de: 'German',
    el: 'Greek',
    gu: 'Gujarati',
    ht: 'Haitian Creole',
    ha: 'Hausa',
    he: 'Hebrew',
    hi: 'Hindi',
    hu: 'Hungarian',
    is: 'Icelandic',
    ig: 'Igbo',
    id: 'Indonesian',
    ga: 'Irish',
    it: 'Italian',
    ja: 'Japanese',
    kn: 'Kannada',
    kk: 'Kazakh',
    km: 'Khmer',
    ko: 'Korean',
    ky: 'Kyrgyz',
    lo: 'Lao',
    lv: 'Latvian',
    lt: 'Lithuanian',
    lb: 'Luxembourgish',
    mk: 'Macedonian',
    ms: 'Malay',
    ml: 'Malayalam',
    mt: 'Maltese',
    mr: 'Marathi',
    mn: 'Mongolian',
    ne: 'Nepali',
    no: 'Norwegian (Bokmål)',
    ps: 'Pashto',
    fa: 'Farsi (Persian)',
    pl: 'Polish',
    pt: 'Portuguese (Brazil)',
    pt_pt: 'Portuguese (Portugal)',
    pa: 'Punjabi',
    ro: 'Romanian',
    ru: 'Russian',
    rs: 'Serbian',
    si_lk: 'Sinhala',
    sk: 'Slovak',
    so: 'Somali',
    mx: 'Spanish',
    es_mx: 'Spanish (Mexico)',
    sw: 'Swahili',
    se: 'Swedish',
    tg: 'Tajik',
    ta: 'Tamil',
    te: 'Telugu',
    th: 'Thai',
    bo: 'Tibetan',
    tr: 'Turkish',
    uk: 'Ukrainian',
    ur: 'Urdu',
    uz: 'Uzbek',
    vi: 'Vietnamese',
    cy: 'Welsh',
    xh: 'Xhosa',
    yo: 'Yoruba',
    zu: 'Zulu',
};

const intlDisplayNames = typeof Intl !== 'undefined'
    ? new Intl.DisplayNames(['en'], { type: 'language' })
    : null;

function resolveIntlLanguageName(platformCode) {
    if (!intlDisplayNames || !platformCode) return null;
    const normalized = String(platformCode).trim();
    const awsBase = PLATFORM_TO_AWS_BASE[normalized]
        || normalized.replace('_', '-').split('-')[0].toLowerCase();
    try {
        const name = intlDisplayNames.of(awsBase);
        if (name && name !== awsBase) return name;
    } catch (e) {
        // ignore
    }
    return null;
}

function getLanguageFullName(languageShort) {
    switch (languageShort) {
        case 'bg': {
            return 'Български (Bulgarian)';
        }
        case 'cz': {
            return 'Čeština (Czech)';
        }
        case 'de': {
            return 'Deutsch (German)';
        }
        case 'en': {
            return 'English';
        }
        case 'fr': {
            return 'Français (French)';
        }
        case 'ho': {
            return 'Nederlands (Dutch)';   // Dutch
        }
        case 'hr': {
            return 'Hrvatski (Croatian)';   // Croatian
        }
        case 'hu': {
            return 'Magyar (Hungarian)';
        }
        case 'it': {
            return 'Italiano (Italian)';
        }
        case 'mx': {
            return 'Español (Spanish)';   // Assuming 'mx' refers to Mexican Spanish
        }
        case 'no': {
            return 'Norsk (Norwegian)';
        }
        case 'ro': {
            return 'Română (Romanian)';
        }
        case 'rs': {
            return 'Српски (Serbian)';   // Serbian (Cyrillic)
        }
        case 'se': {
            return 'Svenska (Swedish)';   // Swedish
        }
        case 'si': {
            return 'Slovenščina (Slovenian)';   // Slovenian
        }
        case 'tr': {
            return 'Türkçe (Turkish)';
        }
        case 'us': {
            return 'English (USA)';
        }
        case 'pl': {
            return 'Polski (Polish)';
        }
        default: {
            if (UI_I18N_DISPLAY_NAMES[languageShort]) {
                return UI_I18N_DISPLAY_NAMES[languageShort];
            }
            return resolveIntlLanguageName(languageShort) || 'Unknown Language';
        }
    }
}

function getAllLanguages() {
    let allLanguages = ['bg', 'de', 'en', 'us', 'mx', 'fr', 'hr', 'it', 'hu', 'ho', 'no', 'pl', 'ro', 'si', 'se', 'rs', 'cz', 'tr'];
    return allLanguages;
}

export { getLanguageFullName, getAllLanguages };
